<template>
  <v-group
    ref="group"
    :config="clockGroupCnfig"
    @click="onGroupClick"
    @tap="onGroupClick"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut" >
    <v-text :config="textConfig"></v-text>
  </v-group>
</template>

<script>
// import { mapGetters } from 'vuex';

import moment from '@/moment-gp.js';

export default {
  props: {
    x: {},
    y: {},
    offsetX: {
      default: 0
    },
    offsetY: {
      default: 0
    },
    editable: {},
  },
  data: () => ({
    timerId: null,
    timerText: ''
  }),
  mounted() {
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  computed: {
    user_get_timezone() {
      return this.$models.userSettings.getters.user_get_timezone
    },

    clockGroupCnfig() {
      return {
        x: this.x,
        y: this.y,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
      };
    },
    textConfig() {
      return {
        draggable: this.editable,
        fill: 'white',
        offsetX: 0,
        offsetY: 0,
        fontSize: 30,
        fontStyle: 'bold',
        text: this.timerText,
      }
    }
  },
  methods: {
    start() {
      this.timerId = setInterval(this.update, 1000);
    },
    update() {
      // this.timerText = moment().format('HH:mm:ss');
      this.timerText = moment.tz(this.user_get_timezone).format('HH:mm');
    },
    onGroupClick(event) {
      let node = this.$refs.group.getNode();
      this.$emit('select', {
        type: 'clock',
        node,
      })
    },
    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },
    onMouseOut(event) {
      document.body.style.cursor = 'default';
    }
  }
}
</script>
